
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gcHvAOOQtfzB_45IahQTz9boF_45Xc6vrEHEcX_45l1Pqc8OsAMeta } from "/codebuild/output/src2388507835/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexp_45F2SvQ1JFnJ_rKXrYAKWEOk490jCjm7ltOiWM4bX6wMeta } from "/codebuild/output/src2388507835/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as search_45MEqEvmI0c2H5IpwGQJS6QfEn7bPAsQfliNtn8opcFoMeta } from "/codebuild/output/src2388507835/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexC7TZvezhYRKsYWHX0HhdLWShWayV6wy_45VLEjtPO2TV4Meta } from "/codebuild/output/src2388507835/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93c_6m31b2pbm7vrMBHyyKm9KGyF9vGANAVBRIJDZtKIUMeta } from "/codebuild/output/src2388507835/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexauKK5gGDqnPHo5kFUkW6Zd1iFr0Zjxt49axED38ASe8Meta } from "/codebuild/output/src2388507835/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93Xj0bBROArYmMVtywwyAefdxPQsgzc3Mqh_eW_45qhYVcAMeta } from "/codebuild/output/src2388507835/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexuF8BeO_45_U5AQWgstxrhwowpregJzqel7oqcj8OM4WsAMeta } from "/codebuild/output/src2388507835/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93OYw_45OK0TyLMucxq2yh3mgdTlU2nVSYkA6sr8lkI1EY4Meta } from "/codebuild/output/src2388507835/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexQqUwU_45U1iNrCaZhusN4pn8VwRjVlegqM4gK4svnGBAIMeta } from "/codebuild/output/src2388507835/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexoGvBlsq40y8inw7BMnmjEeCIFxKLXuk_UXi_1Ac1WUMMeta } from "/codebuild/output/src2388507835/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src2388507835/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2388507835/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2388507835/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src2388507835/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src2388507835/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexauKK5gGDqnPHo5kFUkW6Zd1iFr0Zjxt49axED38ASe8Meta || {},
    component: () => import("/codebuild/output/src2388507835/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src2388507835/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexuF8BeO_45_U5AQWgstxrhwowpregJzqel7oqcj8OM4WsAMeta || {},
    component: () => import("/codebuild/output/src2388507835/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src2388507835/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexQqUwU_45U1iNrCaZhusN4pn8VwRjVlegqM4gK4svnGBAIMeta || {},
    component: () => import("/codebuild/output/src2388507835/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexoGvBlsq40y8inw7BMnmjEeCIFxKLXuk_UXi_1Ac1WUMMeta || {},
    component: () => import("/codebuild/output/src2388507835/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]